export enum TreeType {
  Public = 0,
  Advisor = 1,
  AdvisorFreemium = 2
}
